import { api } from "@/lib/api";

const CTA_RE = /\bcta\b|call to action/i;

export function scriptBlocks(r) {
  const beats = r.script.beats;
  if (r.platform === "x_thread") return beats.map((b, i) => ({ label: `Post ${i + 1}`, text: b.voiceover }));
  if (r.platform === "youtube_long") return beats.map((b) => ({ label: b.label, text: b.voiceover }));
  if (beats.length < 3) return [{ label: "Script", text: beats.map((b) => b.voiceover).join("\n\n") }];
  const join = (list) => list.map((b) => b.voiceover).join("\n\n");
  let cta = beats.map((b, i) => (i > 0 && CTA_RE.test(b.label || "") ? i : -1)).filter((i) => i > 0);
  if (!cta.length) cta = [beats.length - 1];
  const first = cta[0], last = cta[cta.length - 1];
  return [
    { label: "Hook", text: beats[0].voiceover },
    { label: "Body", text: join(beats.slice(1, first)) },
    { label: "CTA", text: join(cta.map((i) => beats[i])) },
    { label: "Loop ending", text: join(beats.slice(last + 1)), minor: true },
  ].filter((b) => b.text);
}

export const cleanText = (r) => r.script.beats.map((b) => b.voiceover).join("\n\n");

export const blocksText = (r) => scriptBlocks(r).map((b) => `${b.label.toUpperCase()}\n${b.text}`).join("\n\n");

export async function download(path, params = {}, fallback = "viral-os-export") {
  const { toast } = await import("sonner");
  const tid = toast.loading("Downloading…");
  try { await save(path, params, fallback); toast.success("Download ready", { id: tid }); } catch (e) { toast.dismiss(tid); throw e; }
}

async function save(path, params, fallback) {
  const res = await api.get(path, { params, responseType: "blob" });
  const m = /filename="([^"]+)"/.exec(res.headers["content-disposition"] || "");
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = m?.[1] || fallback;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}
